// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type { BaseResponseZendeskConfigTicketFoundResponse } from '../../../types';

/**
 * cancelAuth
 *
 * @export
 * @tags zendesk-config-ticket-controller
 * @link [PUT] /zendeskConfigs/ticket/cancelAuth
 */
export function putZendeskConfigsTicketCancelAuth(): Promise<BaseResponseZendeskConfigTicketFoundResponse>;
export function putZendeskConfigsTicketCancelAuth(
    options: ApiOptions<never, never>
): Promise<BaseResponseZendeskConfigTicketFoundResponse>;
export function putZendeskConfigsTicketCancelAuth(
    options?: ApiOptions<never, never>
): Promise<BaseResponseZendeskConfigTicketFoundResponse> {
    return request<never, never, never>('/zendeskConfigs/ticket/cancelAuth', {
        ...options,
        method: 'put',
        __$requestCalleeName: 'putZendeskConfigsTicketCancelAuth',
    });
}

export const meta = [
    {
        tags: ['zendesk-config-ticket-controller'],
        path: '/zendeskConfigs/ticket/cancelAuth',
        method: 'put',
    },
];
